import './style.css';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import {transformExtent} from 'ol/proj.js';
import {fromLonLat as fo} from 'ol/proj.js';
import LayerSwitcher from 'ol-ext/control/LayerSwitcher';
import ScaleLine from 'ol/control/ScaleLine';
import Zoom from 'ol/control/Zoom';
import {Image as ImageLayer} from 'ol/layer.js';
import ImageWMS from 'ol/source/ImageWMS.js';
import GEOJSON from 'ol/format/GeoJSON.js';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import XYZ from 'ol/source/XYZ';
import { toLonLat } from 'ol/proj.js';
import {checkFileExists, fetchdat, generateLinks } from './bplandataloader.js'; // zusätzliche datei für mehr Ordnung ...
import FullScreen from 'ol/control/FullScreen';

var popupcontent;
const csvUrl = 'Bst_bplandata.csv';  // URL zur CSV-Datei
var status1;
var gemeindename = "Bargfeld-Stegen";
function getRandomColor() {
  return `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 0.3)`;
}

const extent_Bargfeld = transformExtent([
  10.122780, // minX bei Rade
  53.734593, // minY
  10.254632,  // maxX
  53.798617   // maxY
],'EPSG:4326','EPSG:3857');

// Funktion zum Extrahieren von URL-Parametern mit Standardwerten
function getHashParams() {
  const hash = window.location.hash.substring(1);
  const params = new URLSearchParams(hash);

  // Standardwerte, falls Parameter fehlen oder ungültig sind
  const defaultLon = 10.187202;  // Berlin
  const defaultLat = 53.767483;
  const defaultZoom = 14;

  let lon = parseFloat(params.get("lon"));
  let lat = parseFloat(params.get("lat"));
  let zoom = parseInt(params.get("zoom"));

  // Überprüfen, ob die Werte gültig sind, sonst Standard setzen
  if (isNaN(lon) || lon < -180 || lon > 180) lon = defaultLon;
  if (isNaN(lat) || lat < -90 || lat > 90) lat = defaultLat;
  if (isNaN(zoom) || zoom < 1 || zoom > 20) zoom = defaultZoom;

  return { lon, lat, zoom };
}

// Parameter auslesen oder Standardwerte setzen
const { lon, lat, zoom } = getHashParams();

const highlightStyle = new Style({
  fill: new Fill({ color: 'rgba(255, 255, 0, 0.2)' }), // Gelb als Highlight
  stroke: new Stroke({ color: '#ff0000', width: 3 }) // Rote Umrandung
});

const grayscaleLayer = new TileLayer({
  source: new OSM({
  attributions: [
    '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  ]  
  })
  
  ,title: 'OSM grayscale',
  className: 'grayscale-layer' // CSS-Klasse für gezieltes Styling
});

var ortho = new ImageLayer({
  source: new ImageWMS ({
  //projection: projx,
  url: 'https://dienste.gdi-sh.de//WMS_SH_DOP20col_OpenGBD?',
  //crossOrigin: 'anonymous',
  params: {LAYERS: 'sh_dop20_rgb',VERSION:'1.3.0' }}),
  title: 'DOP20',
  visible: false, 
  opacity: 0 // initial nicht sichtbar ...
  
  });

  const bst_bplan_polygone = new VectorSource({
    url: 'b-st_Bplan_polygone.geojson',
    crossOrigin: 'anonymous',
    format: new GEOJSON()
    }  ); 

    const bplanstyle = function (feature) {
      // Falls das Feature noch keine Farbe hat, generiere eine
      if (!feature.get('color')) {
          feature.set('color', getRandomColor());
      }

      return new Style({
          fill: new Fill({
              color: feature.get('color') // Setzt die gespeicherte Farbe
          }),
          stroke: new Stroke({
              color: 'rgba(0, 0, 200, 1)', // blaue Umrandung
              width: 1.5
          })
      });
  }

  const bplanpolygonlayer = new VectorLayer({
    source: bst_bplan_polygone, 
    //Projection: 'EPSG:3857',
    title: 'B-Pläne',
    style: bplanstyle,
    crossOrigin: 'anonymous',
    //minZoom: 13.5, 
    
    //minZoom: 13.5,
    opacity:  1 // initial nicht voll sichtbar...
    });

  var gemgrenzen = new VectorSource({
    url: 'gemeindegrenzen_amt-b-l.geojson',
    crossOrigin: 'anonymous',
    format: new GEOJSON()
    }  );

  const transparentstyle = new Style({
    fill: new Fill({
        color: 'transparent'//'rgba(255, 0, 0, 0.5)' // Rote Füllung mit 50% Transparenz
    }),
    stroke: new Stroke({
        color: '#ff0000', // Rote Umrandung
        width: 4 // Linienbreite
    })
});
const attributstyle = function getatributstyle(feature) {
  const typ = feature.get('gemeinde'); // Hole das Attribut "type"

  let fillColor = 'rgba(100, 100, 100, 0.5)'; // Standard-Grau

  if (typ != gemeindename) {
      fillColor = 'rgba(127, 127, 127, 0.2)'; // grau für nicht Bargfeld
  } else if (typ === gemeindename) {
      fillColor = 'rgba(0, 0, 255, 0)'; // Blau für Bargfeld
  }

  return new Style({
      fill: new Fill({
          color: fillColor
      }),
      stroke: new Stroke({
          color: '#1a0172',//'#000000', // rote Umrandung gestrichelt
          width: 3,
          lineDash: [10,10]
      })
  });
};


  const grenzlayer = new VectorLayer({
    source: gemgrenzen, 
    //Projection: 'EPSG:3857',
    title: 'Gemeindegrenzen',
    style: attributstyle,
    //crossOrigin: 'anonymous',
    //minZoom: 13.5,  
    
    //minZoom: 13.5,
    opacity:  1 // initial voll sichtbar...
    });

    const osmkarte = new TileLayer({
      source: new OSM({
        attributions: [
          '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        ] 

    }),
      title: 'OSM',
      visible: false
    });
    


const map = new Map({
  target: 'map',
  layers: [osmkarte,ortho,grayscaleLayer,grenzlayer,bplanpolygonlayer
  ],
  view: new View({
    //center: fo([10.187202,53.767483]),
    center: fo([lon,lat]),
    zoom: zoom//,
    //extent: extent_Bargfeld
  }),
  controls: [
    new Zoom(), // Standard-Zoom-Buttons
    new FullScreen()
  ]
});


var layersw = new LayerSwitcher({
  reverse: false, // Reihenfolge beibehalten
  groupSelectStyle: 'none' // Keine Hierarchieverschiebung möglich
});
map.addControl(layersw);

const scaleLineControl = new ScaleLine({
  units: 'metric' // Alternativ: 'imperial'
});

map.addControl(scaleLineControl);

// Zoomstufe anzeigen
const zoomDisplay = document.getElementById('zoom_display');
zoomDisplay.innerText = map.getView().getZoom().toFixed(1);
map.getView().on('change', () => {
  const view = map.getView();
  const center = toLonLat(view.getCenter());
  const newZoom = view.getZoom();
  window.location.hash = `lon=${center[0].toFixed(6)}&lat=${center[1].toFixed(6)}&zoom=${Math.round(newZoom)}`;
});

// Funktion zum Kopieren der URL in die Zwischenablage
function copyToClipboard() {
  const url = window.location.href;
  navigator.clipboard.writeText(url).then(() => {
      //alert("Kartenausschnitt-URL kopiert!");
  }).catch(err => {
      console.error("Fehler beim Kopieren: ", err);
  });
}

document.getElementById('copy-button').addEventListener('click', function(){

  copyToClipboard();
});
function center_to_gemeinde(lonx,laty) {
   map.getView().setCenter(fo([lonx,laty]));
   const zoom = map.getView().getZoom();
   window.location.hash = `lon=${lonx}&lat=${laty}&zoom=${14}`;
   map.getView('change:center');
   
}

// Aktualisieren, wenn gezoomt wird
map.getView().on('change:resolution', () => {
    zoomDisplay.innerText = map.getView().getZoom().toFixed(1);
});

// Tooltip-Element erstellen
const tooltip = document.createElement('div');
tooltip.className = 'tooltip';
document.getElementById('map').appendChild(tooltip);


// CSS für Tooltip
const tooltipStyle = document.createElement('style');
tooltipStyle.innerHTML = `
    .tooltip {
        position: absolute;
        background: rgba(0, 0, 0, 0.7);
        color: white;
        padding: 5px 10px;
        font-size: 12px;
        border-radius: 4px;
        display: none;
        pointer-events: none;
        white-space: nowrap;
        offset-x:-20px;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
        
    }
`;
document.head.appendChild(tooltipStyle);

//document.getElementById('map').style.filter = 'grayscale(100%)'; gilt aber für alle Layer :-(
  let highlightedFeature = null;

// Funktion zum Verstecken des Tooltips
const hideTooltip = () => {
  tooltip.style.display = 'none';
};
let popupVisible = false; // Variable zur Steuerung des Pointermove-Events

  // Event-Listener für Mausbewegung
map.on('pointermove', function (evt) {
  if (popupVisible) return; // Ignoriere das Event, wenn das Popup aktiv ist
  map.getTargetElement().style.cursor = ''; // Standard-Cursor
  const feature = map.forEachFeatureAtPixel(evt.pixel, (feature, layer) => {
 return layer === bplanpolygonlayer ? feature : null; // Prüft, ob Feature zum gewünschten Layer gehört
});
 

  if (highlightedFeature && highlightedFeature !== feature) {
      highlightedFeature.setStyle(null); // Zurück zum Standard-Style
      highlightedFeature = null;
  }

  if (feature) {
      feature.setStyle(highlightStyle); // Highlight setzen
      highlightedFeature = feature;
      map.getTargetElement().style.cursor = 'pointer'; // Mauszeiger ändern

       // Tooltip-Position setzen und anzeigen
       const coordinates = evt.coordinate;
       tooltip.style.left = evt.pixel[0] - 80 + 'px';
       tooltip.style.top = evt.pixel[1] - 40 + 'px';
       tooltip.style.display = 'block';

       // Tooltip-Text aus den Feature-Attributen setzen (z. B. Name oder ID)
       tooltip.innerHTML = 'B-Plan ' +feature.get('Name') || 'Kein Name';
  } else {
    hideTooltip(); // Falls kein Feature vorhanden ist, Tooltip verstecken
}
});
const nEvent = new Event("urlsfound");
var linkdata;
var hrefdatabplan ='x';
const link1 = '';
var name ='';
var description ='';
var plannr = '';

// Event-Listener für Klick auf das Feature (Popup öffnen)
map.on('singleclick', async function (evt) {
  if (evt.originalEvent.target.closest('#popup')) {
    // Klick INS Popup -> Popup bleibt offen
    return;
}
  const feature = map.forEachFeatureAtPixel(evt.pixel, (feature, layer) => {
      return layer === bplanpolygonlayer ? feature : null; // Nur Features aus dem gewünschten Layer
  });

  if (feature) {
    popupVisible = true; // Pointermove-Event deaktivieren
          // Popup-Position setzen (Mit Umrechnung auf das richtige Koordinatensystem)
     //const coordinates = evt.coordinate;     
    const popupCoordinate = evt.pixel; //map.getCoordinateFromPixel(evt.pixel);
      popup.innerHTML='';
    //popup = document.getElementById('popup');
      // Popup-Position setzen und anzeigen
      popup.style.left = popupCoordinate[0] + 10 + 'px';
      popup.style.top = popupCoordinate[1] + 10 + 'px';
      //popup.style.width = '400px';
      popup.style.display = 'block';

      // Popup-Inhalt (Daten + Link)
       name = feature.get('Name') || 'Kein Name';
       description = feature.get('Name') || 'Keine Beschreibung';
       plannr = 'B-Plan ' + name;
       async function loadlinks() {
       linkdata = await generateLinks(name,hrefdatabplan); 
       }
      loadlinks();
      setTimeout(() => {
        document.dispatchEvent(nEvent);
       }, 200);

       
       
       //popup.innerHTML = linkdata;
      //if (name === '3 B') {
        
         //if ( checkFileExists(csvUrl)) {
        // alert("datei ist vorhanden");
          // Popup-Inhalt setzen
        
      // if (hrefdatabplan !='x') {
           
      //alert(csvUrl);

    
      
    
      //popup.innerHTML = hrefdatabplan + 
     
      //}
      
       //  }
     // } else {
      
      // Popup-Inhalt setzen
     /*  popup.innerHTML = `
          <strong>${name}</strong><br>
          <!--<p>${description}</p>-->
          <a href="${link1}" target="_blank" class="popupLink">${plannr} </a><br>
          <a href="${link1}" target="_blank" class="popupLink">${plannr} Begründung </a><br>
          <a href="${link1}" target="_blank" class="popupLink">${plannr} Zusammenfassende Erklärung</a>
           <br>
            <button id="closePopup">Schließen</button>
        */

      /*`;*/ // }
     
     
        
  } else {
      popupVisible = false; // Pointermove-Event wieder aktivieren
      popup.style.display = 'none'; // Popup ausblenden, wenn kein Feature geklickt wurde
      popupVisible = false;

  }
});
popup.innerHTML ='';

window.addEventListener("DOMContentLoaded", function () {
  
const popupcont = document.createElement('div');
popupcont.id = 'popupcontent';

document.getElementById('popup').appendChild(popupcont);

this.document.getElementById('bst').addEventListener('click',function() {
  gemeindename = "Bargfeld-Stegen";
  center_to_gemeinde(10.189796,53.765337);
});
this.document.getElementById('del').addEventListener('click',function() {
  gemeindename = "Delingsdorf";
  center_to_gemeinde(10.255203,53.705123);
});
this.document.getElementById('elm').addEventListener('click',function() {
  gemeindename = "Elmenhorst";
  center_to_gemeinde(10.267692,53.765957);
});
this.document.getElementById('ham').addEventListener('click',function() {
  gemeindename = "Hammoor";
  center_to_gemeinde(10.322002,53.712890);
});
this.document.getElementById('jer').addEventListener('click',function() {
  gemeindename = "Jersbek";
  center_to_gemeinde(10.222256,53.731759);
});
this.document.getElementById('nie').addEventListener('click',function() {
  gemeindename = "Nienwohld";
  center_to_gemeinde(10.193991,53.785241);
});
this.document.getElementById('to').addEventListener('click',function() {
  gemeindename = "Todendorf";
  center_to_gemeinde(10.349196,53.695145);
});
this.document.getElementById('tre').addEventListener('click',function() {
  gemeindename = "Tremsbüttel";
  center_to_gemeinde(10.317664,53.749648);
});



 status1 = document.getElementById("statuszeile");
  status1.innerHTML="content loaded ...";
  async function loaddata() {
    hrefdatabplan = await fetchdat(csvUrl);
     }
      loaddata();
      setTimeout(() => {
       }, 500);    
        //alert(hrefdatabplan);
        //document.dispatchEvent(nEvent);   
   
  //console.log("Alle Inhalte (einschließlich Bilder, CSS, etc.) sind geladen.");
});

// **Verhindert, dass das Popup bei Klick geschlossen wird**
popup.addEventListener('click', function (e) {
  e.stopPropagation();
});

document.addEventListener('fullscreenchange', () => {
  map.updateSize();
});
document.addEventListener("urlsfound", function(){
  
  //status1.innerHTML = linkdata;
  //status1.innerHTML = hrefdatabplan;
//alert('event urlsfound!');
// erst jetzt sind alle Daten aus der datei geladen ...
var x = 

    `<div id="popupcontent">${linkdata} </div> 
    <br>  
    <button id="closePopup">Schließen</button>
      
      `; 
      //alert('vor einbau in html: ' + hrefdatabplan);
      popup.innerHTML = x;

      document.getElementById('closePopup').addEventListener('click', function (e) {
        e.stopPropagation(); // Verhindert, dass die Karte den Klick verarbeitet
        popup.style.display = 'none';
        popupVisible = false; // Pointermove-Event wieder aktivieren
        popup.innerHTML ='';
    });  

     
      
});

    // Popup nicht schließen, wenn auf Links oder Buttons geklickt wird!
   /*  document.getElementById('popupLink').addEventListener('click', function (e) {
      e.stopPropagation(); // Verhindert, dass OpenLayers das als Kartenklick erkennt
  });  */ 
  // Schließen-Button für das Popup
 